export const getMaxBirthdate = (): string => {
	const dateMinus18years = new Date();
	dateMinus18years.setFullYear(new Date().getFullYear() - 18);

	return dateMinus18years.toISOString().split('T')[0];
};
